export default __webpack_public_path__ + "static/media/glasses.1fd91f0e.png";